import { snapshot } from 'valtio';
import { Order } from 'common-types';
import ApplicationsStore, {
  defaultOrderBy,
} from '../stores/applications-store';
import { loadApplications } from './applications-actions';

export const sortApplications = (field?: string) => {
  field ? sortByField(field) : sortByDefault();
};

const sortByDefault = () => {
  ApplicationsStore.orderByCategory = undefined;
  if (ApplicationsStore.orderField === defaultOrderBy.field) {
    ApplicationsStore.orderDirection =
      ApplicationsStore.orderDirection === Order.Asc ? Order.Desc : Order.Asc;
  } else {
    ApplicationsStore.orderField = defaultOrderBy.field;
    ApplicationsStore.orderDirection = defaultOrderBy.direction;
  }
  executeSort();
};

const sortByField = (field: string) => {
  if (isCategory(field)) {
    ApplicationsStore.orderByCategory = field;
    ApplicationsStore.orderField = 'CategoryViolations';
  } else {
    ApplicationsStore.orderByCategory = undefined;
    ApplicationsStore.orderField = field;
  }
  ApplicationsStore.orderDirection = resolveSortDirection(field);
  executeSort();
};

const executeSort = () => {
  ApplicationsStore.offset = 0;
  loadApplications({ update: true });
};

const resolveSortDirection = (field: string) => {
  const existingField =
    ApplicationsStore.orderByCategory || ApplicationsStore.orderField;

  if (existingField === field) {
    return ApplicationsStore.orderDirection === Order.Asc
      ? Order.Desc
      : Order.Asc;
  }

  return Order.Desc;
};

const isCategory = (catId: string) => {
  const { categories } = snapshot(ApplicationsStore);
  const isFound = categories?.find(
    category => category.catId === parseInt(catId),
  );
  return !!isFound;
};
